<template>
    <div>
        <Headers :title="title" />
        <img class="GDTE" src="~statics/mobileShouye/GDTE.png" alt="">
        <!--<iframe class="iframe" ref="iframe" src="https://720.cloudvhall.com/shidai/zhoushandao-mb"  style="border:0;" ></iframe>-->
        <iframe class="iframe" ref="iframe" src="https://720.cloudvhall.com/shidai/33-mobile"  style="border:0;" ></iframe>
        <!--
        <div class="detaileMenu">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/storeMenu.png" alt="" @click="toStroeCenter">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/cardMenu.png" alt="" @click="toCardCenter">
        </div>
        <van-notice-bar
        class="noticebar"
        left-icon="volume-o"
        mode="closeable"
        text="【近期展会】：08.30~09.03 2021年浙江（舟山市）出口网上交易会（东盟站-水产品专场）"
        />
        -->
        <Footers />
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers"
import Footers from "../mobileExhibition/components/Footers";
import { mapState } from "vuex";

export default {
    data(){
        return{
            // title: null,
            // language: null
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return this.language == 'zh' ? '全球数字贸易云展会平台' : 'Global digital trade cloud exhibition platform'
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        
    },
    mounted(){
        window.addEventListener("message",(res)=>{
            if(res.data && typeof(res.data) == 'string'){
                this.$router.push({
                    path: '/mobileExhibitors',
                })
            }
        });
    },
    methods: {
        toStroeCenter(){
            if(!this.userInfo.id){
                this.$notify(this.$t('area').loginTip)
                setTimeout(()=>{
                    this.$router.push({
                        path: '/mobileLogin'
                    },3600)
                })
            }else{
                this.$router.push({
                    path: '/collection'
                })
            }
        },
        toCardCenter(){
            if(!this.userInfo.id){
                this.$notify(this.$t('area').loginTip)
                setTimeout(()=>{
                    this.$router.push({
                        path: '/mobileLogin'
                    },3600)
                })
            }else{
                this.$router.push({
                    path: '/cardHolder'
                })
            }
        }
    },
    components: {
        Footers,
        Headers
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.noticebar{
    width: 6.9rem;
    height: .72rem;
    opacity: 0.6;
    background: #194b96;
    border-radius: 6px;
    position: absolute;
    bottom: 2.2rem;
    left: .3rem;
    right: .3rem;
}
.GDTE{
    width: 3.56rem;
    height: .4;
    margin: .3rem 0 0 .3rem;
    position: absolute;
    z-index: 999;
}
.detaileMenu{
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 3.22rem;
    right: .14rem;
    .detaileMenu-icon{
        width: 1.12rem;
        height: 1.12rem
    }
}
.iframe{
    width: 100%;
    border: 0px;
    height: 16.3rem;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileIslandZhouShan/index.vue